import { initReactI18next } from 'react-i18next/initReactI18next';
import i18next, { type i18n, type InitOptions } from 'i18next';

import { defaultLocale, locales } from './config';
import { missingKeyLogger } from './missingKeyLogger';
import { type I18nResources } from './types';

interface Config {
    namespaces: string[];
    resources: I18nResources;
}

export function createClient(config: Config): i18n {
    const options: InitOptions = {
        ns: config.namespaces,
        lng: defaultLocale,
        resources: config.resources,
        supportedLngs: locales,
        fallbackLng: defaultLocale,
        debug: process.env['DEBUG_I18N'] === 'true',
        load: 'currentOnly' as const,
    };

    // Set server options
    if (typeof window === 'undefined') {
        // Handle missing keys on the server
        if (process.env['NODE_ENV'] === 'development') {
            options.saveMissing = true;
            options.missingKeyHandler = (_lng, ns, key) => {
                void missingKeyLogger({ ns, key });
                return key;
            };
        }
    }

    // Set client options
    if (typeof window !== 'undefined') {
        options.interpolation = {
            escapeValue: false,
        };
        options.react = {
            useSuspense: false,
        };
    }

    const instance = i18next.createInstance();
    instance.use(initReactI18next);
    void instance.init(options);

    return instance;
}
